"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestSlotValueToString = requestSlotValueToString;
const dateTime_1 = require("../dateTime");
/**
 * Convert a request slot value to a string, helpful for display or debugging.
 *
 * @param value - Slot value to convert to a string
 * @returns String suitable for console statements or display
 */
function requestSlotValueToString(value) {
    let displayValue = `${value}`;
    if (Array.isArray(value)) {
        displayValue = `[${value.toString()}]`;
    }
    else if ((0, dateTime_1.isDateTime)(value) || (0, dateTime_1.isDateTimeRange)(value)) {
        displayValue = (0, dateTime_1.dateTimeToString)(value);
    }
    return displayValue;
}
//# sourceMappingURL=requestSlotValueToString.js.map